import axios, { AxiosError } from "axios";
import { AuthTokenError } from "../../errors/authTokenError";

/**
 * Configuração para as APIs que não necessitam de autenticação
 * @param signOut - Função de logout
 * @returns Instância da API configurada
 */

export function SetupNotAuth(/* signOut: () => void */) {
  const baseURL =
    import.meta.env.MODE === "production"
      ? import.meta.env.VITE_BASE_URL_PROD
      : import.meta.env.VITE_BASE_URL_DEV;

  const api = axios.create({
    baseURL,
    // headers: {
    //   'ngrok-skip-browser-warning': '69420',
    // },
  });

  api.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      if (error.response?.status === 401) {
        // signOut();
        return typeof window === "undefined"
          ? Promise.reject(new AuthTokenError())
          : Promise.reject(error);
      }
      return Promise.reject(error);
    }
  );

  return api;
}
